import { Component, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormsService } from '../../../shared/forms.service';
import { UserService } from '../user.service';
import { UserFormService } from '../user-form.service';
import { AdminFormComponent } from '../../admin/shared/admin-form/admin-form.component';
import { UserGenericComponent } from '../../user-generic.component';
import { SchoolFormComponent } from '../../school/shared/school-form/school-form.component';
import { CustomerFormComponent } from '../../customer/shared/customer-form/customer-form.component';
import { ConsigneeFormComponent } from '../../consignee/shared/consignee-form/consignee-form.component';
import { AlertService } from '../../../shared/alert.service';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss', '../invalid-form.scss'],
  providers: [UserFormService]
})
export class UserFormComponent implements OnInit {

  userId: number;
  userForm: FormGroup;
  btnMsg: string;
  feedBackMsg: string;
  userLoaded = false;
  userRole: number;
  edit = false;
  hasAddress = false;

  msg = {
    'updateSuccess': 'Usuario actualizado correctamente',
    'createSuccess': 'Usuario creado correctamente',
    'createError': 'Debe seleccionarse un rol de usuario',
    'nameRequired': 'Debe especificar su nombre',
    'nameLength': 'Nombre muy largo',
    'lastNameRequired': 'Debe especificar su apellido',
    'lastNameLength': 'Apellido muy largo',
    'emailRequired': 'Debe especificar su correo',
    'emailLength': 'Email muy largo',
    'emailFormat': 'Formato de correo incorrecto',
    'departamentRequired': 'Debe especificar su departamento',
    'departamentLength': 'Nombre del departamento muy largo',
    'cityRequired': 'Debe especificar su localidad',
    'cityLength': 'Nombre de localidad muy largo',
    'streetRequired': 'Debe especificar dirección',
    'streetLength': 'Dirección muy larga',
    'streetNumberRequired': 'Debe especificar número de puerta',
    'streetNumberLength': 'Número de puertra muy largo',
    'apt': 'Largo de número de apartamento muy largo',
    'zipCodeRequired': 'Debe especificar código postal',
    'zipCodeLength': 'Código postal muy largo',
    'zipCodePattern': 'Formato no válido. Debe ingresar un valor numérico.',
    'phoneLength': 'Número de teléfono muy largo',
    'phoneFormat': 'Formato no válido.',
  };

  @ViewChild(AdminFormComponent)
  public adminFormComponent: UserGenericComponent;
  @ViewChild(CustomerFormComponent)
  public customerFormComponent: UserGenericComponent;
  @ViewChild(ConsigneeFormComponent)
  public consigneeFormComponent: UserGenericComponent;
  @ViewChild(SchoolFormComponent)
  public schoolFormComponent: UserGenericComponent;


  public currentSpecificComponent: UserGenericComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private formsService: FormsService,
    private userFormService: UserFormService,
    private alertService: AlertService,
    private userService: UserService) {

    this.createFormGroup();

  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['userId']) {
        this.btnMsg = 'Actualizar';
        this.userId = +params['userId'];
        this.feedBackMsg = '';
        this.userForm.get('userRoleId').disable();
        this.edit = true;
        this.hasAddress = true;

        this.userService.getUser(params['userId'])
        .subscribe(
          userResponse => {
            this.userForm.patchValue(userResponse);
            this.userRole = userResponse['userRoleId'];

            switch (userResponse['userRoleId']) {
              case 1:
                this.currentSpecificComponent = this.adminFormComponent;
                this.currentSpecificComponent.setValue(userResponse);
                break;
              case 2:
                this.currentSpecificComponent = this.customerFormComponent;
                this.currentSpecificComponent.setValue(userResponse);
                break;
              case 3:
                this.currentSpecificComponent = this.consigneeFormComponent;
                this.currentSpecificComponent.setValue(userResponse);
                break;
              case 4:
                this.currentSpecificComponent = this.schoolFormComponent;
                this.currentSpecificComponent.setValue(userResponse);
                break;
              default:
                return;
            }
            this.userLoaded = true;
            if (!userResponse.address) {
              this.toggleAddress();
            }
          },
          error => {
            console.error(error);
            const errorMessage = error._body ? JSON.parse(error._body).message : error.message;
            this.alertService.error(errorMessage);
          }
        );
      } else {
        this.btnMsg = 'Crear';
        this.userForm.get('userRoleId').enable();
        this.userForm.controls['departament'].disable();
        this.userForm.controls['city'].disable();
        this.userForm.controls['address'].disable();
        this.userForm.controls['number'].disable();
        this.userForm.controls['apt'].disable();
        this.userForm.controls['zip'].disable();
      }
    });
  }

  submitForm() {
    let address = null;
    if (this.hasAddress) {
      address = {
        'departament': this.userForm.controls['departament'].value,
        'city': this.userForm.controls['city'].value,
        'address': this.userForm.controls['address'].value,
        'number': this.userForm.controls['number'].value,
        'apt': this.userForm.controls['apt'].value,
        'zip': this.userForm.controls['zip'].value
      };
    }
    const userObject = {
      'active': this.userForm.controls['active'].value,
      'name': this.userForm.controls['name'].value,
      'lastName': this.userForm.controls['lastName'].value,
      'email': this.userForm.controls['email'].value,
      'address': address,
      'phone': this.userForm.controls['phone'].value,
    };
    if (this.userForm.get('userRoleId').value) {
      const validUserForm = this.formsService.validateFormAndUpdateErrors(this.userForm);
      const validcurrentSpecificForm = this.currentSpecificComponent.validateFormAndUpdateErrors();

      let successMessage = this.userId ? 'updateSuccess' : 'createSuccess';
      if (validUserForm && validcurrentSpecificForm) {
        this.currentSpecificComponent.submitForm(userObject, this.userId)
        .subscribe(
          response => {
            console.log('Response:', response);
            if (!this.userId) {
              this.userId = response.id;
              this.btnMsg = 'Actualizar';
              this.userForm.get('userRoleId').disable();
            }
          },
          error => {
            console.error(error);
            let errorMessage;
            if (error._body) {
              const body = JSON.parse(error._body);
              errorMessage = body.message;
              if (body.developerMessage) {
                errorMessage += ` (${body.developerMessage})`;
              }
            } else {
              errorMessage = error.message;
            }
            this.alertService.error(errorMessage);
          },
          () => {
            this.alertService.success(this.msg[successMessage]);
          }
        );
        return;
      }
    } else {
      this.alertService.error(this.msg['createError']);
    }
  }

  toggleAddress() {
    this.hasAddress = !this.hasAddress;
    if (this.hasAddress) {
      this.userForm.controls['departament'].enable();
      this.userForm.controls['city'].enable();
      this.userForm.controls['address'].enable();
      this.userForm.controls['number'].enable();
      this.userForm.controls['apt'].enable();
      this.userForm.controls['zip'].enable();
    } else {
      this.userForm.controls['departament'].disable();
      this.userForm.controls['city'].disable();
      this.userForm.controls['address'].disable();
      this.userForm.controls['number'].disable();
      this.userForm.controls['apt'].disable();
      this.userForm.controls['zip'].disable();
    }
  }

  public specificUserHandler(value) {
    let val = +value;
    this.userRole = val;
    switch (val) {
      case 1:
        this.currentSpecificComponent = this.adminFormComponent;
        break;
      case 2:
        this.currentSpecificComponent = this.customerFormComponent;
        break;
      case 3:
        this.currentSpecificComponent = this.consigneeFormComponent;
        break;
      case 4:
        this.currentSpecificComponent = this.schoolFormComponent;
        break;
      default:
        this.currentSpecificComponent = this.adminFormComponent;
    }
  }

  public createFormGroup() {
    this.userForm = this.fb.group({
      'name': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'lastName': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'email': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50),
          Validators.email
        ])
      ],
      'departament': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'city': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'address': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100)
        ])
      ],
      'number': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'apt': [
        null,
        Validators.compose([
          Validators.maxLength(50)
        ])
      ],
      'zip': [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern('[0-9]+'),
          Validators.maxLength(50)
        ])
      ],
      'userRoleId': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'phone': [
        null,
        Validators.compose([
          Validators.maxLength(50)
        ])
      ],
      'active': [
        true
      ]
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/user/shared/user-form/user-form.component.ts